import React from 'react';
import { Checkbox, FormControlLabel } from '@material-ui/core';

import styles from './SelectAll.module.scss';
import { noOp } from '../../../../../utils/helper-functions';

interface Props {
  readonly selectedCount: number;
  readonly total: number;
  readonly onChange?: (isSelected: boolean) => void;
}

export const SelectAll = ({ selectedCount, total, onChange = noOp }: Props) => {
  return (
    <>
      <div className={styles.selectedCounter}>
        {`${selectedCount} of ${total} Selected`}
      </div>
      <FormControlLabel
        classes={{ label: styles.selectAllLabel }}
        control={
          <Checkbox
            color="primary"
            checked={selectedCount > 0 && selectedCount === total}
            onChange={event => {
              onChange(event.target.checked);
            }}
          />
        }
        label="Select all"
      />
    </>
  );
};
